import React from 'react'
import JoinRoom from './JoinRoom'
import CreateRoom from './CreateRoom'
import { Card, Button } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

const Lobby = _ => {
	const ButtonElement = props => {
		return React.createElement(
			props.loading ? LoadingButton : Button,
			props
		)
	}

	return (
		<Card>
			<JoinRoom ButtonElement={ButtonElement} />
			<CreateRoom ButtonElement={ButtonElement} />
		</Card>
	)
}

export default Lobby
